import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["nameDisplay", "nameInput"]
  static values = {
    assetId: String,
    updateUrl: String
  }

  connect() {
    // Asset edit controller for inline rename functionality
  }

  // Inline rename functionality
  startRename(event) {
    event.preventDefault()
    event.stopPropagation() // Prevent lightbox from opening

    this.nameDisplayTarget.classList.add("hidden")
    this.nameInputTarget.classList.remove("hidden")
    this.nameInputTarget.focus()
    this.nameInputTarget.select()
  }

  cancelRename(event) {
    if (event.key === "Escape") {
      this.nameInputTarget.value = this.nameDisplayTarget.textContent.trim()
      this.nameDisplayTarget.classList.remove("hidden")
      this.nameInputTarget.classList.add("hidden")
    }
  }

  async saveRename(event) {
    if (event.type === "blur" || (event.type === "keydown" && event.key === "Enter")) {
      event.preventDefault()

      const newName = this.nameInputTarget.value.trim()
      if (!newName) {
        this.nameInputTarget.value = this.nameDisplayTarget.textContent.trim()
        this.cancelRename({ key: "Escape" })
        return
      }

      try {
        const response = await fetch(this.updateUrlValue, {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": this.getCsrfToken(),
            "Accept": "application/json"
          },
          body: JSON.stringify({
            asset: { name: newName }
          })
        })

        if (response.ok) {
          const data = await response.json()
          this.nameDisplayTarget.textContent = data.name
          this.nameDisplayTarget.classList.remove("hidden")
          this.nameInputTarget.classList.add("hidden")
        } else {
          throw new Error("Update failed")
        }
      } catch (error) {
        console.error("Rename error:", error)
        alert("Failed to rename asset")
        this.nameInputTarget.value = this.nameDisplayTarget.textContent.trim()
        this.cancelRename({ key: "Escape" })
      }
    }
  }

  getCsrfToken() {
    return document.querySelector('meta[name="csrf-token"]').content
  }
}
